module.exports = __webpack_public_path__ + "static/media/edit-collection.df454234.svg";